import React from 'react';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import PropTypes from 'prop-types';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@uhg-abyss/web/ui/Button';
import { storage } from '@uhg-abyss/web/tools/storage';
import { config } from '@uhg-abyss/web/tools/config';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import { styled } from '@uhg-abyss/web/tools/styled';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';

const StyledModalSection = styled(Modal.Section, {
  margin: '40px 70px',
});

const StyledLayoutStack = styled(Layout.Stack, {
  '&.abyss-layout-stack': {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  '& .abyss-text-root': {
    maxWidth: '550px',
    textAlign: 'center',
    lineHeight: '1.5',
    wordWrap: 'break-word',
    margin: '0 auto',
    display: 'block',
    color: '$gray9',
  },
});

const StyledHeading = styled(Heading, {
  fontSize: '30px !important',
  fontWeight: '400 !important',
});

export const ErrorModal = ({ isOpen }) => {
  const { getMessage, getFeature } = usePPDLagoon();
  const termsOfUseErrorMessage = getMessage('terms-of-use-error-message');
  const handleSignOut = () => {
    const permissionsStorageKey = 'provider-permissions';
    storage.local.remove(permissionsStorageKey);
    window.location.href = getFeature('OHID_SESSION_REWORK')
      ? `${config('IDENTITY_API_URL')}/logout/v2`
      : `${config('IDENTITY_API_URL')}/logout`;
  };
  return (
    <Modal
      titleAlign="center"
      isOpen={isOpen}
      hideClose
      data-testid="terms-and-conditions-error-modal"
    >
      <StyledModalSection>
        <StyledLayoutStack alignLayout="center" alignItems="center">
          <IconBrand size="72" icon="alert" />
          <StyledHeading
            data-testid="terms-and-conditions-error-title"
            display="h3"
          >
            Unable to log response
          </StyledHeading>
          <Text data-testid="terms-and-conditions-error-desc">
            {termsOfUseErrorMessage}
          </Text>
          <Button onClick={handleSignOut}>Sign out</Button>
        </StyledLayoutStack>
      </StyledModalSection>
    </Modal>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
